module.exports = __webpack_public_path__ + "img/thumb_05.2bfe229e.jpg";